import * as React from 'react';
import type { HolOutput } from './holiday';
import type { HolidayThemeId } from './registry';

interface HolidayContextValue {
  /** The theme the holiday schedule gives for today. */
  themeId: HolidayThemeId;
  /** Everything the UI renders for the current theme; `hol.show` is false for None. */
  hol: HolOutput;
}

export const HolidayContext = React.createContext<HolidayContextValue | null>(null);

export function useHoliday(): HolidayContextValue {
  const ctx = React.useContext(HolidayContext);
  if (!ctx) throw new Error('useHoliday() must be used inside <HolidayProvider>');
  return ctx;
}
